module.exports = __webpack_public_path__ + "img/03.271aae54.jpg";